// extracted by mini-css-extract-plugin
export default {"moduleWrapper":"marcaturaCE_moduleWrapper__XOFVV","documentRow":"marcaturaCE_documentRow__CBQDf","documentRow_marmi":"marcaturaCE_documentRow_marmi__tVfWe"};